module.exports = "<horizontal-navigation-bar  ng-if=\"!$ctrl.isGuestUser\"></horizontal-navigation-bar>\n<ui-view></ui-view>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/billing/components/billing/billing.component.html
// module id = 524
// module chunks = 0